import React, { useMemo, useState, useEffect } from "react";
import ReactImageMagnify from "react-image-magnify";

const ImageSection = ({ productDataById }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleVerticalClick = (index) => {
        setCurrentIndex(index);
    };

    const defaultImg = "/images/defaultImage.png";

    const imageList = useMemo(() => {
        // 1. direct images array from new API
        if (productDataById?.images?.length > 0) {
            return productDataById.images.map((img) => ({
                imgPath: img,
            }));
        }

        // 2. fallback images_full_url
        if (productDataById?.images_full_url?.length > 0) {
            return productDataById.images_full_url.map((img) => ({
                imgPath: img?.key || img?.path,
            }));
        }

        // 3. fallback colors_formatted images
        if (productDataById?.colors_formatted?.length > 0) {
            return productDataById.colors_formatted.map((item) => ({
                imgPath: item?.image,
            }));
        }

        // 4. fallback thumbnail
        if (productDataById?.thumbnail_full_url) {
            return [
                {
                    imgPath: productDataById.thumbnail_full_url,
                },
            ];
        }

        return [];
    }, [productDataById]);

    useEffect(() => {
        setCurrentIndex(0);
    }, [productDataById]);

    const currentImage =
        imageList?.[currentIndex]?.imgPath || defaultImg;

    return (
        <div className="col-lg-5">
            <div className="image_wrep_main d-sm-flex">
                {/* Desktop Thumbnails */}
                <div className="imge_wepper d-sm-block d-none col-sm-2">
                    {imageList?.slice(0, 5).map((item, i) => (
                        <div
                            className={`img_book ${i === currentIndex ? "slick-current" : ""}`}
                            key={i}
                            onClick={() => handleVerticalClick(i)}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={item?.imgPath || defaultImg}
                                alt={`Thumbnail ${i + 1}`}
                            />
                        </div>
                    ))}
                </div>

                {/* Main Image */}
                <div className="col-sm-10 col-12">
                    {currentImage && (
                        <ReactImageMagnify
                            {...{
                                smallImage: {
                                    alt: productDataById?.name || "Product Image",
                                    isFluidWidth: true,
                                    src: currentImage,
                                },
                                largeImage: {
                                    src: currentImage,
                                    width: 1200,
                                    height: 1800,
                                },
                                enlargedImageContainerStyle: {
                                    zIndex: 2000,
                                    backgroundColor: "#fff",
                                },
                                enlargedImageContainerDimensions: {
                                    width: "130%",
                                    height: "100%",
                                },
                                isHintEnabled: false,
                            }}
                        />
                    )}
                </div>

                {/* Mobile Thumbnails */}
                <div
                    className="imge_wepper d-sm-none d-flex col-12 mt-3"
                    style={{ gap: "10px", flexWrap: "wrap" }}
                >
                    {imageList?.slice(0, 5).map((item, i) => (
                        <div
                            className={`img_book ${i === currentIndex ? "slick-current" : ""}`}
                            key={i}
                            onClick={() => handleVerticalClick(i)}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={item?.imgPath || defaultImg}
                                alt={`Thumbnail ${i + 1}`}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageSection;